export const SET_LOADING = "setLoading";
export const SET_ERROR = "setError";
export const SET_RESET = "setReset";
export const SET_BANNERS = "setBanners";


